import { observer } from 'mobx-react-lite'
import { match } from '@/utils/pattern-match-util'
import { OCRScopeJobScopingInProgress } from '@/features/jobs/scoping/components/OCRScopeJobScopingInProgress'
import { OCRScopeJobErrorOccurred } from '@/features/jobs/scoping/components/OCRScopeJobErrorOccurred'
import { OCRScopeJobUnderReview } from '@/features/jobs/scoping/components/OCRScopeJobUnderReview'
import { OCRScopeJobUnselected } from '@/features/jobs/scoping/components/OCRScopeJobUnselected'
import { OCRScopeNewJobButtonContainer } from '@/features/jobs/scoping/components/OCRScopeNewJobButton/OCRScopeNewJobButtonContainer'
import { type OCRScopingJobsViewModel } from '@/features/jobs/scoping/OCRScopingJobsViewModel'
import { OCRScopeJobDetailBody } from '@/features/jobs/scoping/components/OCRScopeJobDetailBody'
import { OCRScopeJobDetailBodyMainContainer } from './OCRScopeJobDetailBodyMainContainer'

export interface OCRScopeJobDetailBodyContainerProps {
  vm: OCRScopingJobsViewModel
}

export const OCRScopeJobDetailBodyContainer = observer(
  function OCRScopeJobDetailBodyContainer({
    vm,
  }: OCRScopeJobDetailBodyContainerProps) {
    const mainPanelVm = vm.mainPanelVm
    const selectedScopeWork = mainPanelVm.selectedScopeWork
    const canManageOCRScopingJobs = mainPanelVm.canManageOCRScopingJobs

    return (
      <OCRScopeJobDetailBody>
        {!mainPanelVm.hasScopeWork ? (
          <OCRScopeJobUnselected>
            <OCRScopeNewJobButtonContainer vm={vm.createScopeJobsVm} />
          </OCRScopeJobUnselected>
        ) : (
          match(selectedScopeWork.status, {
            ScopingInProgress: () => <OCRScopeJobScopingInProgress />,
            ErrorOccurred: () => <OCRScopeJobErrorOccurred />,
            ReviewRequired: () =>
              canManageOCRScopingJobs ? (
                <OCRScopeJobDetailBodyMainContainer vm={mainPanelVm} />
              ) : (
                <OCRScopeJobUnderReview fileName={selectedScopeWork.fileName} />
              ),
            ReviewSuggested: () =>
              canManageOCRScopingJobs ? (
                <OCRScopeJobDetailBodyMainContainer vm={mainPanelVm} />
              ) : (
                <OCRScopeJobUnderReview fileName={selectedScopeWork.fileName} />
              ),
            ReadyToSubmit: () => (
              <OCRScopeJobDetailBodyMainContainer vm={mainPanelVm} />
            ),
            Completed: () => (
              <OCRScopeJobDetailBodyMainContainer vm={mainPanelVm} />
            ),
            Unknown: () => null,
          })
        )}
      </OCRScopeJobDetailBody>
    )
  },
)
